var map = {
	"./arrow-left.svg": "d402",
	"./cart.svg": "e5bc",
	"./chart.svg": "1aca",
	"./check-circle.svg": "5db6",
	"./check.svg": "912b",
	"./close.svg": "c120",
	"./easter-egg.svg": "224d",
	"./fire.svg": "1d36",
	"./heart.svg": "9239",
	"./info.svg": "97fa",
	"./leads-coins.svg": "0f2d",
	"./league-bronze.svg": "0282",
	"./league-gold.svg": "1663",
	"./league-silver.svg": "201bd",
	"./loader.svg": "9e6f",
	"./present.svg": "124f",
	"./profil.svg": "ed1f",
	"./question-circle.svg": "cc95",
	"./rating.svg": "93f0",
	"./social-fb.svg": "e798",
	"./social-tg.svg": "eed2",
	"./social-vk.svg": "d7d14",
	"./social-youtube.svg": "da92",
	"./star.svg": "e034",
	"./support.svg": "d785",
	"./sync.svg": "bc12",
	"./telegram-bot.svg": "160f",
	"./tickets.svg": "8fac",
	"./times-circle.svg": "aec9",
	"./trash.svg": "8338"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "368c";